

const SocialHandle = () => {

    const social = {
        instagram: "./img/instagram.png",
        twitter: "./img/twitter.png",
        threads: "./img/threads.png",
        email: "./img/mail.png",
        facebook: "./img/facebook.png",
        github: "./img/github.png",
        linkedin: "./img/linkedin.png"
    }
    
    return (
        <section className="social-section">

            <h4>Let's Connect</h4>
            <p>Follow me on Social Media or reach out for collaborations:</p>
            <div className="social-links">
            <a  href="https://www.instagram.com/prec10us._/">{<img className="handle" src={social.instagram} alt="insta"/>}</a>
            <a  href="https://www.threads.com/@prec10us._">{<img className="handle" src={social.threads} alt="threads"/>} </a>
            <a  href="https://x.com/prec10us_m">{<img className="handle" src={social.twitter} alt="X"/>}</a>
            <a  href="mailto:ayeniprecious025@gmail.com">{<img className="handle" src={social.email} alt="email"/>}</a>
            <a href="https://github.com/ayeniprecious" >{<img className="handle" src={social.github} alt="github"/>}</a>
            <a href="https://www.linkedin.com/in/precious-ayeni-63453136a/" >{<img className="handle" src={social.linkedin} alt="linkedin"/>}</a>
            <a  href="https://www.facebook.com/profile.php?id=61577776282749&mibextid=wwXIfr&mibextid=wwXIfr">{<img className="handle" src={social.facebook} alt="facebook"/>}</a>
            </div>
            
        </section>
    );


};

export default SocialHandle;